import React from 'react';
import { motion } from 'framer-motion';
import { useLibrary } from '../context/LibraryContext';
import { useBooks } from '../context/BooksContext';
import './ReaderLevel.css';

const LEVELS = [
  { name: 'Novice', emoji: '🌱', minBooks: 0 },
  { name: 'Lecteur', emoji: '📖', minBooks: 2 },
  { name: 'Passionné', emoji: '🔥', minBooks: 5 },
  { name: 'Expert', emoji: '🧠', minBooks: 10 },
  { name: 'Maître', emoji: '👑', minBooks: 20 },
  { name: 'Légende', emoji: '⭐', minBooks: 50 },
];

export default function ReaderLevel() {
  const { library, getProgress } = useLibrary();
  const { getBookById } = useBooks();

  // Compter les livres terminés
  const booksFinished = library.filter(book => {
    const fullBook = getBookById(book.id);
    if (!fullBook || fullBook.chapters.length === 0) return false;
    return getProgress(book.id) >= fullBook.chapters.length - 1;
  }).length;

  // Déterminer le niveau actuel et le suivant
  let currentLevel = LEVELS[0];
  let nextLevel = LEVELS[1];
  for (let i = LEVELS.length - 1; i >= 0; i--) {
    if (booksFinished >= LEVELS[i].minBooks) {
      currentLevel = LEVELS[i];
      nextLevel = LEVELS[i + 1] || null;
      break;
    }
  }

  const progress = nextLevel
    ? ((booksFinished - currentLevel.minBooks) / (nextLevel.minBooks - currentLevel.minBooks)) * 100
    : 100;

  return (
    <div className="level-widget">
      <div className="level-header">
        <motion.span
          className="level-emoji"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 400 }}
        >
          {currentLevel.emoji}
        </motion.span>
        <div className="level-info">
          <p className="level-name">{currentLevel.name}</p>
          <p className="level-progress-text">
            {nextLevel
              ? `${booksFinished}/${nextLevel.minBooks} livres pour ${nextLevel.emoji} ${nextLevel.name}`
              : 'Niveau max atteint !'}
          </p>
        </div>
      </div>
      {nextLevel && (
        <div className="level-bar">
          <motion.div
            className="level-bar-fill"
            initial={{ width: 0 }}
            animate={{ width: Math.min(progress, 100) + '%' }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          />
        </div>
      )}
    </div>
  );
}